import React, { useState, useEffect } from 'react';
import { func, string, object, bool } from 'prop-types';
import { map, get, times, find, size, filter, isEmpty } from 'lodash';
import { FlexContainer, Column, Text, Button, Row, Divider } from '../../src/components/common';
import styled from 'styled-components';
import { withApollo } from 'react-apollo';
import BAGGING_FINISH from '../../src/components/graphql/bagging';
import { Modal } from 'antd';

const Quantity = styled.div`
    color: #a4c735;
    width: 45px;
    font-weight: bold;
    height: 34px;
    background-color: #ffffff;
    text-align: center;
    margin-right: 3px;
    line-height: 30px;
`;

const Icon = ({ iconName }) => {
    return (
        <span className={`icon-ic-${iconName}`} style={{ fontSize: 35, marginRight: 15 }}>
            <span className='path1' />
            <span className='path2' />
            <span className='path3' />
            <span className='path4' />
            <span className='path5' />
            <span className='path6' />
        </span>
    );
};

Icon.propTypes = {
    iconName: string
};

const typesBagging = [
    { type: 1, name: 'smallBag', label: 'Bolsa', icon: 'bag', active: true },
    { type: 2, name: 'mediumBag', label: 'Bolsa Mediana', icon: 'bag', active: false },
    { type: 3, name: 'bigBag', label: 'Bolsa Grande', icon: 'bag', active: false },
    { type: 4, name: 'boxBag', label: 'Caja', icon: 'box-bag', active: true },
    { type: 5, name: 'backPack', label: 'Mochila', icon: 'backpack', active: true },
    { type: 6, name: 'package', label: 'Bulto', icon: 'package', active: false },
    { type: 7, name: 'fresh', label: 'Frescos', icon: 'fresh', active: false },
    { type: 8, name: 'frozen', label: 'Congelados', icon: 'frozen', active: false },
    { type: 9, name: 'thermalBag', label: 'Bolso Térmico', icon: 'thermal-bag', active: false }
];

const ModalBodyBagging = ({ orderId, toggleModal, client, visibleModal, salesChannelId }) => {
    const [bagging, setBagging] = useState({});
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [success, setSuccess] = useState(false);
    const [visible, setVisible] = useState(visibleModal);

    useEffect(() => {
        setVisible(visibleModal);
    }, [visibleModal]);

    const onChangeBagging = (key, action) => {
        let quantity = get(bagging, key) || 0;

        if (action === 'plus') {
            quantity++;
        } else {
            quantity > 0 && quantity--;
        };

        setBagging({ ...bagging, [key]: quantity });
    };

    const cleanBagging = (baggingDetail) => {
        return filter(baggingDetail, (bag) => size(get(bag, 'bag')) > 0);
    };

    const handleConfirm = () => {
        setLoading(true);
        const baggingDetail = map(bagging, (value, key) => {
            return { bag:
                times(value, (item) => {
                    return {
                        type: get(find(typesBagging, { name: key }), 'type'),
                        correlative: item + 1,
                        id: ''
                    };
                })
            };
        });


        client.mutate({
            mutation: BAGGING_FINISH,
            variables: { input: { orderId, salesChannelId, baggingDetail: cleanBagging(baggingDetail) } }
        })
        .then(({ data }) => {
            const { internalCode } = get(data, 'finish');
            setLoading(false);
            if (internalCode === '200') {
                setSuccess(true);
                setTimeout(() => handleCancel(), 1000);
            } else {
                setError(true);
            };
        });
    };

    const isDisabled = () => {
        if (success) return success;
        return isEmpty(filter(bagging, (value, key) => value > 0));
    };

    const handleCancel = () => {
        setVisible(false);
        toggleModal();
        setTimeout(() => {
            setBagging({});
            setError(false);
            setSuccess(false);
        }, 1000);
    };

    return (
        <Modal
            title='Embolsado'
            visible={visible}
            footer={null}
            onCancel={handleCancel}
            width={430}
        >
            {map(filter(typesBagging, { active: true }), (item) => {
                const name = get(item, 'name');
                return (<div key={get(item, 'type')}>
                    <FlexContainer justify='center' align='center' style={{ width: '100%', marginBottom: 10 }}>
                        <Icon iconName={get(item, 'icon')} />
                        <Column style={{ lineHeight: '30px' }}>
                            <Text size={15} text={get(item, 'label')} strong />
                        </Column>
                        <Row flex={2} justify='flex-end'>
                            <Quantity>{get(bagging, name) || 0}</Quantity>
                            <Button secondary right={3} width={45} className={`icon-ic-minus`}
                                onClick={() => onChangeBagging(name, 'minus')}
                            />
                            <Button width={45} className={`icon-ic-plus`}
                                onClick={() => onChangeBagging(name, 'plus')}
                            />
                        </Row>
                    </FlexContainer>
                    <Divider />
                </div>);
            }) }
            <FlexContainer justify='center' align='center' style={{ width: '100%' }} mT={20} direction='column'>
                <Row mB={(error || success) && 10} justify='flex-end'>
                    {error && <Text color='#db5959' text={'No se pudo realizar la operación. Favor intente nuevamente.'} />}
                    {success && <Text color='#1fa02e' text={'Embolsado correctamente.'} />}
                </Row>
                <Row>
                    <Button link text={'btn.action.cancel'} width={100} onClick={() => handleCancel()} />
                    <Button
                        disabled={isDisabled()}
                        loading={loading}
                        text={'btn.action.confirm'}
                        width={100}
                        onClick={() => handleConfirm()} />
                </Row>
            </FlexContainer>
        </Modal>
    );
};

ModalBodyBagging.propTypes = {
    visibleModal: bool,
    orderId: string,
    toggleModal: func,
    client: object,
    salesChannelId: string
};

export default withApollo(ModalBodyBagging);
